var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUnreadMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "currentColour",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.322 8.996L16.5 9l.183-.005.238-.02.08-.01-.001 3.83c0 1.114-.116 1.519-.334 1.926a2.27 2.27 0 01-.945.945c-.407.218-.812.334-1.926.334h-8.59c-1.115 0-1.519-.116-1.926-.334a2.272 2.272 0 01-.945-.945c-.203-.38-.318-.758-.332-1.712L2 7.309l7.277 3.638a.5.5 0 00.447 0l4.937-2.468c.333.205.702.357 1.096.442l.242.043.128.016.195.016zM4.992 4.002L13.336 4l-.05.11-.07.172c-.036.1-.069.2-.096.303l-.052.219-.016.087-.018.11a3.487 3.487 0 00.663 2.598l.14.173L9.5 9.94 2.224 6.303a.499.499 0 00-.18-.051c.052-.45.15-.71.29-.973.218-.407.538-.727.945-.945.38-.203.758-.318 1.712-.332h.001zM16.5 3a2.5 2.5 0 110 5 2.5 2.5 0 010-5z",
    fill: "#A99058"
  })));
}

export default SvgUnreadMail;